export default __webpack_public_path__ + "media/zurb/img/events/wired/dst/dst-photos-5599754d54fd1b4de84b73ef2ee2541e.png";